import { render } from "./HeroiconsOutlineMenuAlt2.vue?vue&type=template&id=24ae0bd4"
const script = {}

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMenuAlt2.vue"]])

export default __exports__